import { render, staticRenderFns } from "./VariationCard.vue?vue&type=template&id=14a2ed02&"
import script from "./VariationCard.vue?vue&type=script&lang=ts&"
export * from "./VariationCard.vue?vue&type=script&lang=ts&"
import style0 from "./VariationCard.vue?vue&type=style&index=0&id=14a2ed02&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports